import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import BatteryChecks from './components/BatteryChecks';

const batteryChecks = (props,{ t }) => (
  <Container>
    <BatteryChecks {...props} />
  </Container>
);

batteryChecks.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(batteryChecks);
